export const TickWithCircle = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g clipPath="url(#clip0_1122_9148)">
      <path
        d="M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C12.7512 1.5 13.4831 1.57876 14.1883 1.7282C14.5935 1.81407 14.9916 1.55519 15.0775 1.14997C15.1633 0.744759 14.9044 0.346655 14.4992 0.260783C13.6924 0.0898084 12.8563 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 11.6637 23.9861 11.3304 23.959 11.0008C23.9249 10.588 23.5626 10.281 23.1498 10.315C22.737 10.3491 22.43 10.7114 22.464 11.1242C22.4878 11.4128 22.5 11.7049 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z"
        fill="currentColor"
      />
      <path
        d="M23.5394 4.02106C23.8272 3.72313 23.819 3.24833 23.5211 2.96056C23.2231 2.67278 22.7483 2.68102 22.4606 2.97895L11.3961 14.4339L6.52658 9.63261C6.23163 9.34179 5.75676 9.34514 5.46594 9.64009C5.17512 9.93504 5.17847 10.4099 5.47342 10.7007L10.8825 16.0341C11.0251 16.1747 11.218 16.2524 11.4182 16.2499C11.6185 16.2475 11.8094 16.1651 11.9485 16.0211L23.5394 4.02106Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1122_9148">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
